var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuCheckBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7292",
    "data-name": "Group 7292",
    transform: "translate(-18 -220)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 45,
    height: 45,
    rx: 10,
    transform: "translate(18 220)",
    fill: "#4b58ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22963",
    "data-name": "Path 22963",
    d: "M4,16v4H8v2H2V16Zm18,0v6H16V20h4V16ZM7.5,7A4.5,4.5,0,0,0,11,11.389V17h2V11.388A4.5,4.5,0,0,0,16.5,7h2A6.5,6.5,0,0,1,15,12.768V19H9V12.768A6.5,6.5,0,0,1,5.5,7ZM12,5A2.5,2.5,0,1,1,9.5,7.5,2.5,2.5,0,0,1,12,5ZM8,2V4H4V8H2V2ZM22,2V8H20V4H16V2Z",
    transform: "translate(29 231)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCheckBlue);
export default __webpack_public_path__ + "static/media/menu-check-blue.620cd43d781058a820e98cfabf319f76.svg";
export { ForwardRef as ReactComponent };